import {Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy} from '@angular/core';
import { Router } from '@angular/router';
import {ReplaySubject, Subscription} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from '@irb/app.service';
import { PageService } from '@irb-common/services/page.service'; 
import { IrbDashboardService } from '@irb/irb-dashboard/irb-dashboard.service';
import {IClientDetails, IGlobalSettings} from '@irb/irb-dashboard/irb-dashboard.model';
import { IrbCreatePortfolioEvents } from '@irb-common/events';
import { IApplyFilterOnLanding } from '@irb/app.model';
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';

@Component({
  standalone: false,
  selector: 'irb-module-clients',
  templateUrl: './module-clients.component.html',
  styleUrls: ['./module-clients.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ModuleClientsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  loadedUnassigned: boolean;
  loadedPfPending: boolean;
  loadedTax: boolean;
  isUnassignActEnabled: boolean = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.isUnassignActEnabled;
  data: any = {
    "totalPortfolioValue": null,
    "totalPortfolio": null,
    "highPriorityNoteCount": null,
    "unassignedAccountCount": null,
    "taxHarExpCount": null,
    "unassignedAccountValue": null,
    "portPendingResultsCount": null
  }
  private masterAccountSubscription: Subscription;
  selectedMasterAccounts: Array<string> = [];
  initailLoadPassed = false;
  ENABLE_CUSTOM_HOMEPAGE: boolean = false;
  @Input() customizableMode: boolean = false;
  @Input() singleWidth: boolean = true;
  @Input() globalSettings: IGlobalSettings;

  constructor(
    public as: AppService,
    public ps: PageService, 
    private dbs: IrbDashboardService,
    private router: Router,
    private ats: AnalyticsService
  ) {
    this.isUnassignActEnabled = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.isUnassignActEnabled;
    this.ENABLE_CUSTOM_HOMEPAGE = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_CUSTOM_HOMEPAGE || false;
  }

  ngOnInit() {
    if (this.customizableMode)
      return;

    this.masterAccountSubscription = this.dbs.currentMasterAccountData.subscribe(passedSelectedMasterAccounts => {
      if (this.initailLoadPassed) {
        this.selectedMasterAccounts = passedSelectedMasterAccounts;
        this.loadedUnassigned = false;
        this.loadedPfPending = false;
        this.loadedTax = false;
        if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
          this.getClientsDataForAllSelectedAccounts();
        else
          this.getClientsDataForAllAccounts();
      }
    });

    this.initailLoadPassed = true;
    this.selectedMasterAccounts = this.dbs.selectedMasterAccounts;
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
      this.getClientsDataForAllSelectedAccounts();
    else
      this.getClientsDataForAllAccounts();
  }

  getClientsDataForAllAccounts() {
    this.dbs.getUnassignAccValueDetails().pipe(takeUntil(this.destroyed$)).subscribe((d: any) => {
      this.loadedUnassigned=true;
      this.data.unassignedAccountCount = d.unassignedAccountCount;
      this.data.unassignedAccountValue = d.unassignedAccountValue;
    });

    this.dbs.getPfPendingResultCount().pipe(takeUntil(this.destroyed$)).subscribe((d: any) => {
      this.loadedPfPending=true;
      this.data.portPendingResultsCount = d.portPendingResultsCount;
    });

    this.dbs.gettaxHarExpCount().pipe(takeUntil(this.destroyed$)).subscribe((d: any) => {
      this.loadedTax=true;
      this.data.taxHarExpCount = d.taxHarExpCount;
    });
  }

  getClientsDataForAllSelectedAccounts() {
    // const payload: any = {masterAccounts: this.selectedMasterAccounts};
    this.dbs.getUnassignAccValueDetailsForMasters(this.selectedMasterAccounts).pipe(takeUntil(this.destroyed$)).subscribe({
      next: (d: any) => {
        this.loadedUnassigned = true;
        this.data.unassignedAccountCount = d.unassignedAccountCount;
        this.data.unassignedAccountValue = d.unassignedAccountValue;
      }
    });

    this.dbs.getPfPendingResultCountForMasters(this.selectedMasterAccounts).pipe(takeUntil(this.destroyed$)).subscribe({
      next: (d: any) => {
        this.loadedPfPending = true;
        this.data.portPendingResultsCount = d.portPendingResultsCount;
      }
    });

    this.dbs.gettaxHarExpCountForMasters(this.selectedMasterAccounts).pipe(takeUntil(this.destroyed$)).subscribe({
      next: (d: any) => {
        this.loadedTax = true;
        this.data.taxHarExpCount = d.taxHarExpCount;
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
    if (this.masterAccountSubscription)
      this.masterAccountSubscription.unsubscribe();
  }

  showCreatePortfolio() {
    this.ats.trackClickEvent("md_createport");
    this.as.fireEvent(IrbCreatePortfolioEvents.SHOW_CREATE_PORTFOLIO);
  }

  showPortfoliosWithPendingResults() {
    let state: any = {
      isUpdatRequired: true,
      filterModels: [
        {name:'pendingResults', value:['Yes'], isUpdatRequired:true}
      ]
    };
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
      state.filterModels.push({name: 'masterAccount', value: this.selectedMasterAccounts, isUpdatRequired: true});

    this.router.navigateByUrl('/rebalancing/rebalance-results', { state: state });
  }

  showTaxHarvestExpiration() {
    let state: any = {
      isUpdatRequired: true,
      filterModels: [
        {name: 'taxlossResults', value: ['Yes'], isUpdatRequired: true}
      ]
    };
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0) {
      state.filterModels.push( {name: 'masterAccount', value: this.selectedMasterAccounts, isUpdatRequired: true});
    }

    this.router.navigateByUrl('/clients/portfolios', { state: state });
  }

  showUnassignedAccounts() {
    this.ats.trackPassiveEvent("lc_unacct");
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0) {
      const state: IApplyFilterOnLanding = {
        isUpdatRequired : true,
        filterModel : {name:'masterAccount', value: this.selectedMasterAccounts, isUpdatRequired:true}
      };
      this.router.navigateByUrl('/clients/unassigned-accounts', { state: state });
      return;
    }
    const state: IApplyFilterOnLanding = {
      isUpdatRequired : true,
      filterModel : {name:'no-filter', value: null, isUpdatRequired:false}
    };

    this.router.navigate(['/clients/unassigned-accounts'], { state: state });
  }
  
  showPortfolios() {
    this.ats.trackPassiveEvent("lc_clients");
    this.router.navigate(['/clients/portfolios']);
  }

}
